//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

export const SEARCH_DEBOUNCE_DELAY = 300;
